import React from 'react';
import CalendarGrid from './CalendarGrid';
import DaySummary from './DaySummary';
import DetailPanel from './DetailPanel';
import HolidayList from './HolidayList';
import { getLunarSpecialNote } from '../utils/lunarNotes';

function CalendarTab({
  t,
  language,
  currentDate,
  monthData,
  selectedDate,
  selectedLunar,
  localizedDayName,
  localizedCanChiYear,
  lunarStemBranchLines,
  weekdayLabel,
  favoriteSet,
  monthlyHolidays,
  holidaysLoading,
  holidaysError,
  detailData,
  detailHandlers,
  onSelectDate,
  onPrevMonth,
  onNextMonth,
  onToday,
  getHolidayName
}) {
  return (
    <>
      <DaySummary
        t={t}
        selectedDate={selectedDate}
        selectedLunar={selectedLunar}
        localizedDayName={localizedDayName}
        localizedCanChiYear={localizedCanChiYear}
        lunarStemBranchLines={lunarStemBranchLines}
        weekdayLabel={weekdayLabel}
      />

      <CalendarGrid
        t={t}
        currentDate={currentDate}
        monthData={monthData}
        selectedDate={selectedDate}
        onSelectDate={onSelectDate}
        favoriteSet={favoriteSet}
        onPrevMonth={onPrevMonth}
        onNextMonth={onNextMonth}
        onToday={onToday}
        getHolidayName={getHolidayName}
        getLunarSpecialNote={(lunar) => getLunarSpecialNote(lunar, language)}
      />

      <div className="info-grid">
        <DetailPanel
          t={t}
          language={language}
          data={detailData}
          handlers={detailHandlers}
        />

        <HolidayList
          t={t}
          monthlyHolidays={monthlyHolidays}
          getHolidayName={getHolidayName}
          isLoading={holidaysLoading}
          error={holidaysError}
        />
      </div>
    </>
  );
}

export default React.memo(CalendarTab);
